<template>
    <span v-html="compMarkup"></span>
</template>

<script setup>

/**
 * import Phone from from '@datatable/columns/Phone'
 * 
 *     <template v-slot:item.phone="{ item }">
 *       <Phone :value="item.phone"/>
 *       <Phone value="112"/>
 *       <Phone :item="item" :fields="['rel_phone','rel_mobile']"/>
 *     </template>
 *
 */

import string from "@lib/string";
import {computed} from 'vue'

const props = defineProps({
    value: {
        type: [String]
    },
    item: {
        type: [Object]
    },
    fields: {
        type: [String, Array]
    }
})

const compMarkup = computed({
    get() {

        var arrMarkup = [];
        // Prefer specific fields. 
        if (props.item && props.fields && props.fields.length) {

            var fields = typeof props.fields == 'string' ? [props.fields] : props.fields;
            fields.forEach(f => {
                if (props.item[f]) {
                    var markup = `<a href="tel:${props.item[f]}">${props.item[f]}</a>`;
                    arrMarkup.push(markup);
                }
            })
        // Otherwise, default to value.
        } else if (!string.isEmpty(props.value)) {
            arrMarkup = [`<a href="tel:${props.value}">${props.value}</a>`];
        }
        // else, no information
        return string.concat(" / ", ...arrMarkup);
    }
})
</script>
